import CustomOfferForm from './CustomOfferForm';
import { types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';

const { Money } = sdkTypes;

// Provider creating a new offer: step 1 with the title, description, pricing
// and schedule fields empty.
export const Empty = {
  component: CustomOfferForm,
  props: {
    formId: 'CustomOfferForm.Empty',
    isProvider: true,
    onSubmit: values => {
      console.log('submit values:', values);
    },
  },
  group: 'forms',
};

// Provider updating an existing offer: every field pre-filled, so the
// "Esikatsele" button is enabled and the preview step can be opened.
export const Prefilled = {
  component: CustomOfferForm,
  props: {
    formId: 'CustomOfferForm.Prefilled',
    isProvider: true,
    initialValues: {
      title: 'Verkkosivujen uudistus ja SEO-optimointi',
      description:
        'Suunnittelen ja toteutan uuden verkkosivuston WordPressillä. Sisältää etusivun, palvelusivut ja yhteydenottolomakkeen sekä perus-SEO:n.',
      customOfferAmount: new Money(250000, config.currency),
      startDate: { date: new Date(2026, 9, 1) },
      deliveryDate: { date: new Date(2026, 10, 15) },
    },
    onSubmit: values => {
      console.log('submit values:', values);
    },
  },
  group: 'forms',
};

// Provider creating an offer on a process that stores files: one uploaded,
// one still uploading, one rejected as too large.
export const WithAttachments = {
  component: CustomOfferForm,
  props: {
    formId: 'CustomOfferForm.WithAttachments',
    isProvider: true,
    attachmentsEnabled: true,
    stagedAttachments: [
      {
        tempId: 'a',
        fileId: 'f-a',
        name: 'tarjous.pdf',
        size: 245760,
        progress: 100,
        state: 'available',
        error: null,
      },
      {
        tempId: 'b',
        fileId: null,
        name: 'luonnos.png',
        size: 1048576,
        progress: 42,
        state: 'uploading',
        error: null,
      },
      {
        tempId: 'c',
        fileId: null,
        name: 'lahdetiedostot.zip',
        size: 2147483648,
        progress: 0,
        state: 'failed',
        error: { status: 413 },
      },
    ],
    onUploadAttachment: file => console.log('upload attachment:', file.name),
    onRemoveAttachment: tempId => console.log('remove attachment:', tempId),
    onSubmit: values => {
      console.log('submit values:', values);
    },
  },
  group: 'forms',
};
